import React from 'react';
import RoleRoute from './RoleRoute';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  return <RoleRoute allowedRoles={['admin']}>{children}</RoleRoute>;
};

export default AdminRoute;
